import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { useNotificationContext } from 'core/states';
import { getFullUrl, goTo } from 'core/utils';
import { orderPartsPath } from 'orders/routes/routePaths';
import { QuoteEntityType } from 'quotes/enums';
import { quotePartsPath } from 'quotes/routes/routePaths';
import { Variant } from 'theme/enums';

export const SeeQuoteButton = ({
  entityType,
  quoteId,
}: {
  entityType: QuoteEntityType;
  quoteId: number;
}) => {
  const { t } = useTranslation();

  const { clearNotification } = useNotificationContext();

  const redirectToQuote = useCallback(
    (quoteId: number) => {
      if (QuoteEntityType.ORDER === entityType) {
        goTo(getFullUrl(orderPartsPath(quoteId)), true);

        return;
      }

      goTo(getFullUrl(quotePartsPath(quoteId)), true);
    },
    [entityType]
  );

  return (
    <Button
      text={t('buttonLabelSeeQuote', { entityType })}
      variant={Variant.SOFT}
      onClick={() => {
        clearNotification();

        if (quoteId) {
          redirectToQuote(quoteId);

          return;
        }
      }}
    />
  );
};
